"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));
var _Link = _interopRequireDefault(require("../../Link"));
var _index = _interopRequireDefault(require("./index.style"));
var _VerticalDivider = _interopRequireDefault(require("../../Icons/VerticalDivider"));
var _Card = _interopRequireDefault(require("../../Card"));
var _InputRangeDate = _interopRequireDefault(require("../InputRangeDate"));
var _Calendar = _interopRequireDefault(require("../Calendar"));
var _Button = _interopRequireDefault(require("../../Button"));
var _calendar = _interopRequireDefault(require("../../../assets/svg/calendar"));
var _NavButton = _interopRequireDefault(require("../NavButton"));
var _dates = require("../../../utils/dates");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line react/display-name
const CalendarPicker = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    datepickerIcon = /*#__PURE__*/_react.default.createElement(_calendar.default, null),
    dividerInputIcon = /*#__PURE__*/_react.default.createElement(_VerticalDivider.default, null),
    placeholderStartDate = 'Start date',
    placeholderEndDate = 'End date',
    resetDatesButtonLabel = 'Reset',
    incomingStartDate = '2021/03/20',
    incomingEndDate = '2021/03/25',
    minAvailableDate = '2021/03/5',
    maxAvailableDate = '2021/04/25',
    startDate = new Date(),
    endDate = new Date(),
    submitDatesButtonLabel = 'Done',
    onDateChange = () => {},
    resetCalendar = () => {}
  } = props;
  const classes = (0, _index.default)();
  const [state, setState] = (0, _react.useState)((0, _dates.buildCalendarStateObject)(startDate, endDate));
  const calendarRef = (0, _react.useRef)();
  const setPickerDates = dates => {
    setState(dates);
  };
  const onDoneClick = () => {
    onDateChange(state);
  };
  const onResetClick = () => {
    setState((0, _dates.buildCalendarStateObject)(incomingStartDate, incomingEndDate));
    resetCalendar();
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapPicker,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: classes.wrapCalendarPicker
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.datepickerHeader
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xl: 6,
    className: classes.datepickerHeaderInputs
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xl: 2
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    component: "button",
    underline: "none",
    className: classes.resetButton,
    onClick: onResetClick
  }, resetDatesButtonLabel)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xl: 10,
    className: classes.datepickerHeaderInput
  }, /*#__PURE__*/_react.default.createElement(_InputRangeDate.default, {
    datepickerIcon: datepickerIcon,
    dividerInputIcon: dividerInputIcon,
    placeholderStartDate: placeholderStartDate,
    placeholderEndDate: placeholderEndDate,
    labelDatepicker: "",
    startDate: state.startDate,
    endDate: state.endDate,
    focusedInput: state.focusedInput
  })))))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.datepickerBody
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.datepickerMessages
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.underscore
  }), " Your sailing dates"), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.datepickerCalendar
  }, /*#__PURE__*/_react.default.createElement(_Calendar.default, {
    maxAvailableDate: maxAvailableDate,
    minAvailableDate: minAvailableDate,
    incomingStartDate: incomingStartDate,
    incomingEndDate: incomingEndDate,
    startDate: state.startDate,
    endDate: state.endDate,
    ref: calendarRef,
    onDateChange: setPickerDates
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.datepickerFooter
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    buttonlabel: submitDatesButtonLabel,
    className: classes.doneButton,
    variant: "contained",
    color: "primary",
    onClick: onDoneClick,
    "data-testid": "doneButton"
  }, submitDatesButtonLabel)))), /*#__PURE__*/_react.default.createElement(_NavButton.default, {
    direction: true,
    onClick: () => calendarRef.current.previousMonth()
  }, /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, {
    fontSize: "small"
  })), /*#__PURE__*/_react.default.createElement(_NavButton.default, {
    onClick: () => calendarRef.current.nextMonth()
  }, /*#__PURE__*/_react.default.createElement(_ChevronRight.default, {
    fontSize: "small"
  }))));
});
var _default = exports.default = CalendarPicker;